import type { RefObject } from "react";
import React from "react";
import {
  EmptyState,
  LoaderWrap,
  LoadMoreSentinel,
  Spinner,
} from "./schedule.styled";

type Props = {
  isLoading: boolean;
  isEmpty: boolean;
  emptyText: string;
  isLoadingMore: boolean;
  loadMoreRef: RefObject<HTMLDivElement>;
  children: React.ReactNode;
};

export const ScheduleViewBody: React.FC<Props> = (props) => {
  if (props.isLoading) {
    return (
      <LoaderWrap>
        <Spinner />
      </LoaderWrap>
    );
  }

  if (props.isEmpty) {
    return <EmptyState>{props.emptyText}</EmptyState>;
  }

  return (
    <>
      {props.children}
      {props.isLoadingMore && (
        <LoaderWrap>
          <Spinner />
        </LoaderWrap>
      )}
      <LoadMoreSentinel ref={props.loadMoreRef} />
    </>
  );
};
